import { render, staticRenderFns } from "./ServerStatus.vue?vue&type=template&id=24095071&"
import script from "./ServerStatus.vue?vue&type=script&lang=js&"
export * from "./ServerStatus.vue?vue&type=script&lang=js&"
import style0 from "./ServerStatus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServerStatus.vue"
export default component.exports